var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 346C276.487 346 347 275.487 347 188.5C347 101.513 276.487 31 189.5 31C102.513 31 32 101.513 32 188.5C32 275.487 102.513 346 189.5 346Z",
    className: "svgStroke",
    strokeWidth: 23.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 179H228.111V286.556H101V179Z",
    className: "svgStroke",
    strokeWidth: 11.7333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.111 257.222V208.333L164.556 237.667L189 208.333V257.222M277 169.222L218.333 120.333M169.444 100.778V130.111L218.333 120.333V91L169.444 100.778ZM228.111 179L277 169.222V271.889L228.111 286.556V179ZM166.912 130.111L101 179H228.111L166.912 130.111Z",
    className: "svgStroke",
    strokeWidth: 11.7333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.6965,
    y: 62,
    width: 314,
    height: 29,
    transform: "rotate(42.7803 83.6965 62)",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.7c53200e.svg";
export { ForwardRef as ReactComponent };